<template>
  <div>
    <!--Web端样式-->
    <div v-if='isCollapse'>
      <el-container class="login-from-box">
        <el-header class='form-header form-login-header'>
          <div class="header-title">
            <span class="tabs-only-one">
              忘记密码
            </span>
          </div>
        </el-header>
        <el-main class="form-body form-login-main">
          <div v-if='showCaptcha'>
            <el-form key="b" class="user-layout-login" ref="formFirst" :model="modelPass" :rules="validatorRulesPass" @keyup.enter.native="checkVerifyImage()">
              <input type="text" autocomplete="off" style="position: fixed;bottom: -9999px;">
              <input type="password" autocomplete="off" style="position: fixed;bottom: -9999px;" />

              <el-form-item required prop="usernameFirst" class="item-first">
                <el-input v-model="modelPass.usernameFirst" size="large" placeholder="请输入手机号"> </el-input>
              </el-form-item>
              <div class="form-code-item" style="display: flex; justify-content: space-between">
                <el-form-item required prop="code">
                  <el-input placeholder="请输入验证码" maxlength="4" size="large" v-model="modelPass.code">
                  </el-input>
                </el-form-item>
                <img @click="getCaptcha" :src="'data:image/jpg;base64,' + baseImg" style="width: 100px; height: 40px; cursor: pointer" alt="" />
              </div>

              <el-form-item class="form-bottom">
                <el-button size="large" type="primary" class="login-button" @click.stop.prevent="checkVerifyImage(3)">下一步
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <el-form key="c" class="user-layout-login" ref="formSec" :model="modelSecond" :rules="validatorRulesSecond" @keyup.enter.native="changePwd()">
              <el-form-item required prop="code">
                <el-input placeholder="请输入验证码" maxlength="6" size="large" v-model="modelSecond.code" autocomplete="off">
                  <template slot="append">
                    <span class="code-text" v-if="canClickCode" @click="getCode">获取验证码</span>
                    <span class="code-timer" v-else>{{ smsBtnTxt }}</span>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item required prop="newPass" class="item-first">
                <el-input v-model="modelSecond.newPass" :type="pcPassNewFlag ? 'password' : 'text'" maxlength="16" size="large" placeholder="请输入新密码" autocomplete="new-password">
                  <template slot="append">
                    <div @click="pcPassNewFlag = !pcPassNewFlag" class="pc-pass">
                      <img v-if="pcPassNewFlag" src="../../../../assets/pcHidden.png" alt="" />
                      <img v-if="!pcPassNewFlag" src="../../../../assets/pcLook.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item required prop="affirmPass">
                <el-input v-model="modelSecond.affirmPass" :type="pcAffirmPassFlag ? 'password' : 'text'" maxlength="16" size="large" placeholder="请确认密码" autocomplete="new-password">
                  <template slot="append">
                    <div @click="pcAffirmPassFlag = !pcAffirmPassFlag" class="pc-pass">
                      <img v-if="pcAffirmPassFlag" src="../../../../assets/pcHidden.png" alt="" />
                      <img v-if="!pcAffirmPassFlag" src="../../../../assets/pcLook.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="form-bottom">
                <el-button size="large" type="primary" class="login-button" :loading="changePassBtn" @click.stop.prevent="changePwd()" :disabled="changePassBtn">确定
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-main>
      </el-container>
    </div>
    <!--App端样式-->
    <div v-else>
      <el-container class='app-login-from-box'>
        <el-header class="form-login-header">
          <div class='app-logo'>
            <img src="../../../../assets/logoApp.png" alt="" />
          </div>
        </el-header>
        <el-main class='form-login-main'>
          <div v-if='showCaptcha'>
            <el-form key="e" class="app-form-login" ref="formFirst" :model="modelPass" :rules="validatorRulesPass" @keyup.enter.native="checkVerifyImage()">
              <el-form-item required prop="usernameFirst" class="item-first">
                <el-input v-model="modelPass.usernameFirst" class="input-icon" size="large" placeholder="请输入手机号">
                  <template slot="prepend">
                    <div class="input-icon-up">
                      <img src="../../../../assets/user.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item required prop="code">
                <el-input placeholder="请输入验证码" maxlength="4" class="input-icon input-icon-two input-icon-tree" size="large" v-model="modelPass.code">
                  <template slot="prepend">
                    <div class="input-icon-up">
                      <img src="../../../../assets/pass.png" alt="" />
                    </div>
                  </template>
                  <template slot="append">
                    <img @click="getCaptcha" :src="'data:image/jpg;base64,' + baseImg" style="width: 54px; height: 30px; cursor: pointer;" alt="" />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="form-bottom">
                <el-button size="large" type="primary" class="login-button" @click.stop.prevent="checkVerifyImage()">下一步
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <el-form key="f" class="app-form-login" ref="formSec" :model="modelSecond" :rules="validatorRulesSecond" @keyup.enter.native="changePwd()">
              <el-form-item required prop="code">
                <el-input placeholder="请输入验证码" maxlength="6" class="input-icon input-icon-two input-icon-tree" size="large" v-model="modelSecond.code" autocomplete="new-password">
                  <template slot="prepend">
                    <div class="input-icon-up">
                      <img src="../../../../assets/pass.png" alt="" />
                    </div>
                  </template>
                  <template slot="append">
                    <div class="code-text" v-if="canClickCode" @click="getCode">获取验证码</div>
                    <div class="code-timer" v-else>{{ smsBtnTxt }}</div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item required prop="newPass" class="item-first">
                <el-input v-model="modelSecond.newPass" class="input-icon" size="large" placeholder="请输入新密码" autocomplete="new-password">
                  <template slot="prepend">
                    <div class="input-icon-up">
                      <img src="../../../../assets/pass.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item required prop="affirmPass">
                <el-input v-model="modelSecond.affirmPass" class="input-icon" size="large" placeholder="请确认密码">
                  <template slot="prepend">
                    <div class="input-icon-up">
                      <img src="../../../../assets/pass.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="form-bottom">
                <el-button size="large" type="primary" class="login-button" :loading="changePassBtn" @click.stop.prevent="changePwd()" :disabled="changePassBtn">确定
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import {
  changeAccountPwd,
  getCaptcha,
  sendChangeLyPwdSms,
  verification
} from '@/api/api.p'

export default {
  name: 'forget-pwd',
  props: {
    isCollapse: {
      type: Boolean,
      value: false,
    }
  },
  data () {
    let validatePhone = (rule, value, callback) => {
      let reg = /^0?1[3|4|5|6|7|8|9]\d{9}$/
      let regEml = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/
      if (value == '') {
        callback(new Error('请输入手机号或邮箱！'))
      } else {
        if (value.indexOf('@') > -1) {
          if (regEml.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确的手机号或邮箱！'))
          }
        } else {
          if (reg.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确的手机号或邮箱！'))
          }
        }
      }
    }
    let validatePassFirst = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入新密码！'))
      } else {
        if (value.length >= 8) {
          callback()
        } else {
          callback(new Error('密码格式不正确！'))
        }
      }
    }
    let validatePass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请确认密码！'))
      } else {
        if (value == this.modelSecond.newPass) {
          callback()
        } else {
          callback(new Error('请输入相同密码！'))
        }
      }
    }
    return {
      showCaptcha: true,
      canClickCode: true,
      modelPass: {
        usernameFirst: '',
        code: '',
      },
      validatorRulesPass: {
        usernameFirst: [{ required: true, validator: validatePhone }],
        code: [{ required: true, message: '请输入验证码（区分大小写）!' }],
      },
      baseImg: '',
      changePassBtn: false,
      modelSecond: {
        newPass: '',
        affirmPass: '',
        code: '',
      },
      validatorRulesSecond: {
        newPass: [{ required: true, validator: validatePassFirst }],
        affirmPass: [{ required: true, validator: validatePass }],
        code: { required: true, message: '请输入验证码!' },
      },
      smsBtnTxt: '',
      timer: null,
      secTime: 59,
      pcPassNewFlag: true, // 忘记密码显示
      pcAffirmPassFlag: true, // 确认密码显示
    }
  },
  mounted () {
    this.getCaptcha();
  },
  methods: {
    checkVerifyImage () {
      this.$refs['formFirst'].validate((valid) => {
        if (valid) {
          this.verification()
        }
      })
    },
    changePwd () {
      this.$refs['formSec'].validate((valid) => {
        if (valid) {
          this.changeAccountPwd()
        }
      })
    },
    // 获取图形验证码
    getCaptcha () {
      getCaptcha().then((res) => {
        if (res && res.meta) {
          if (res.meta.code === 0) {
            this.baseImg = res.data
          } else {
            this.$toast('获取图形码失败');
          }
        } else {
          this.$toast('获取图形码失败');
        }
      })
    },
    // 校验图形验证码
    verification () {
      verification({ verCode: this.modelPass.code })
        .then((res) => {
          if (res && res.meta) {
            if (res.meta.code === 0) {
              if (res.data === true) {
                this.getCode();
              } else {
                this.$toast('图形校验失败');
              }
            } else {
              this.$toast(res.meta.message)
              this.modelPass.code = ''
              this.getCaptcha()
            }
          } else {
            this.$toast('图形校验失败');
          }
        })
        .catch((err) => {
          this.$toast(err.meta.message)
        })
    },
    // 获取验证码
    getCode () {
      if (!this.canClickCode) {
        return false
      }
      this.canClickCode = false

      let params = {
        userEvidence: this.modelPass.usernameFirst,
      }
      sendChangeLyPwdSms(params).then((res) => {
        if (res.meta.code === 0) {
          this.showCaptcha = false;
          this.secTime = 59
          this.smsBtnTxt = this.secTime + 's'
          this.timer = setInterval(() => {
            --this.secTime
            if (this.secTime < 0) {
              clearInterval(this.timer)
              this.canClickCode = true
              // this.smsBtnTxt = '获取验证码'
            } else {
              this.smsBtnTxt = this.secTime + 's'
            }
          }, 1000)
        } else {
          this.$toast(res.meta.message)
          this.canClickCode = true
        }
      })
    },
    // 修改密码
    changeAccountPwd () {
      this.changePassBtn = true
      let params = {
        userEvidence: this.modelPass.usernameFirst,
        changeType: '2', // 密码修改方式:1修改密码；2重置密码，3 首次设置密码
        newPsw: this.modelSecond.newPass,
        verificationCode: this.modelSecond.code,
      }
      changeAccountPwd(params).then((res) => {
        if (res && res.meta) {
          if (res.meta.code === 0) {
            this.$toast(res.meta.message)
            this.modelSecond = {}
            // clearInterval(this.timer)
            this.secTime = 59
            this.changePassBtn = false
            this.$emit('finish', res.data);
            this.showCaptcha = true;
          } else {
            this.changePassBtn = false
            this.$toast(res.meta.message)
          }
        } else {
          this.changePassBtn = false
          this.$toast('修改密码失败')
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.login-title {
  font-size: 20px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 500;
  color: #999999;

  text-align: center;
  padding-bottom: 38px;
}
.tabs-div {
  // flex: 1;
  cursor: pointer;
}
.user-layout-login {
  .item-first {
    margin-bottom: 30px;
  }

  label {
    font-size: 14px;
  }

  .form-bottom {
    position: relative;

    .pass-text {
      // position: absolute;
      // bottom: 40px;
      // right: 0;
      color: #4086f6;
      font-size: 12px;
      cursor: pointer;
      text-align: right;
    }
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
    margin-top: 20px;
  }
}

.app-form-login {
  /deep/.el-input-group--prepend {
    border: 1px solid #f2f2f2;
    // border-radius: 22px;
    border-radius: 8px;
    height: 44px;
    display: flex;
  }

  .input-icon {
    /deep/.el-input-group__prepend,
    /deep/.el-input-group__append {
      min-width: 42px;
      // height: 44px;
      // border-radius: 22px 0 0 22px;
      border-radius: 8px 0 0 8px;
      padding: 0;
      background: rgba(245, 245, 245, 0.2);
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #f2f2f2;
    }

    /deep/.el-input-group__append {
      // border-radius: 0 22px 22px 0;
      border-radius: 0 8px 8px 0;

      .code-timer {
        color: #999;
      }
    }

    /deep/.el-input__inner {
      border: none !important;
      background: rgba(245, 245, 245, 0.2);
      // border-radius: 0 22px 22px 0;
      border-radius: 0 8px 8px 0;
      height: 100%;
      color: #fff;
      font-size: 18px;
    }
  }

  .input-icon-two {
    /deep/.el-input__inner {
      border: none !important;
      background: rgba(245, 245, 245, 0.2);
      border-radius: 0;
      height: 100%;
      color: #fff;
      font-size: 18px;
    }
  }

  .input-icon-tree {
    /deep/.el-input-group__append {
      color: #fff;
      font-size: 15px;
      width: auto;
      min-width: auto;
      padding-right: 15px;

      .code-timer {
        color: #999;
      }
    }
  }

  .input-icon-up {
    width: 16px;
    height: 16px;
    margin-top: -4px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .form-bottom {
    .pass-text {
      text-align: right;
      color: #bfbfbf;
      padding-right: 10px;
    }

    .login-button {
      width: 100%;
      background: #fff;
      // border-radius: 22px;
      border-radius: 8px;
      color: #4086f6;
      font-size: 16px;
      height: 44px;
      border-color: #fff;
    }
  }
}

.pc-pass {
  cursor: pointer;
  img {
    width: 20px;
    height: 20px;
  }
}
</style>
